import React from 'react';

export const ComplianceNote = ({ children, variant = 'info' }) => {
  const styles = variant === 'warning'
    ? 'border-brand-amber/40 bg-amber-50 text-amber-900'
    : 'border-brand-indigo/20 bg-brand-bg text-brand-indigo/80';
  return (
    <div className={`text-[11px] leading-relaxed border rounded-md px-3 py-2 ${styles}`}>
      {children}
    </div>
  );
};

export default ComplianceNote;
